import { Component, Input } from "@angular/core";
import {
  isProfessionalProvider,
  isVolunteer,
} from "../../models/resource-management/company-resource-type-guards";
import CredentialType from "../../models/resource-management/credential-type.enum";
import CredentialedResource from "../../models/resource-management/credentialed-resource";
import ProfessionalProvider from "../../models/resource-management/professional-provider";

@Component({
  selector: "company-resources-detail",
  templateUrl: "company-resources-detail.html",
})
export class CompanyResourcesDetailComponent {
  private _resource: CredentialedResource;
  isProvider: boolean = false;
  isVolunteer: boolean = false;
  CredentialType = CredentialType;

  constructor() {}

  // region Getters and Setters
  get resource(): CredentialedResource {
    return this._resource;
  }

  @Input()
  set resource(value: CredentialedResource) {
    this._resource = value;
    if (isProfessionalProvider(value)) {
      this.isProvider = true;
    }
    if (isVolunteer(value)) {
      this.isVolunteer = true;
    }
  }

  get provider(): ProfessionalProvider {
    return this.resource as ProfessionalProvider;
  }

  get isEmployee(): boolean {
    return this._resource.isEmployee;
  }

  // endregion
}



// WEBPACK FOOTER //
// ./src/components/company-resources-detail/company-resources-detail.ts